import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, take } from "rxjs";
import { ApiService } from "./api.service";
import { UserSettings, Settings, AppData, APIResponse, Utils, ObjectUtils } from "fakturnia-shared";
import { ToastService } from "./toast.service";
import { LogoUtils } from "shared/utils/logo.utils";
import { SubscriptionService } from "./subscription.service";
import { DateFormatService } from "./date-format.service";

@Injectable({
    providedIn: 'root'
})
export class SettingsService {

    private _userSettings:any = new BehaviorSubject<UserSettings | any>(new UserSettings());
    public currentUserSettings = this._userSettings.asObservable();

    constructor(
        private _apiService:ApiService,
        private _toastService:ToastService,
        private _subscriptionService: SubscriptionService,
        private _dateFormatService: DateFormatService
    ) { }

    public refreshSettings() {
        this._apiService.getUserSettings()
        .pipe(take(1))
        .subscribe({
            next: async (response:APIResponse) => {

                if(response.success == false) { 
                    this._toastService.warning(response.message)
                    return
                }
                
                if(response.success == true) {

                   
                    await this.updateUserSettings(response.data);

                }

                
            }
            
        })
    }
    
    public getUserSettings(): Observable<UserSettings> {
        if(this._userSettings.value.settings instanceof Settings && this._userSettings.value.settings.vatRates.length == 0) this._userSettings.value.settings.vatRates = AppData.DefaultVatRates.map(v=>v.value)
        return this._userSettings;
    }

    /**
     * Optymistycznie aktualizuje wybrane pola autouzupełniania w cache (bez
     * pełnego przeładowania z API). Dzięki temu zapis pojedynczego ustawienia
     * nie powoduje "mrugania" pozostałych pól formularza, a reszta aplikacji
     * (np. formularz faktury) i tak widzi aktualne wartości.
     */
    public patchAutocomplete(partial: { [key: string]: any }): void {
        const current = this._userSettings.value;
        if (current?.settings?.autocomplete) {
            Object.assign(current.settings.autocomplete, partial);
            this._userSettings.next(current);
        }
    }

    async updateUserSettings(userSettings:UserSettings | any)
    {
        // if(Utils.isNullOrEmpty(userSettings.settings)) userSettings.settings = new Settings();
        // if(!Utils.isNullOrEmpty(userSettings.settings)) userSettings.settings = Utils.parseJSONToClass(<string>userSettings.settings, Settings) || new Settings();
        // Logo jest kosmetyczne — jego błąd (CORS/404/timeout obrazka) NIE może
        // wywrócić inicjalizacji aplikacji. Pobieramy best-effort.
        const logoUrl = ObjectUtils.getNestedValue(userSettings, 'company.logoUrl')
        if (logoUrl && userSettings.company) {
            try {
                userSettings.company.logo = await LogoUtils.getLogo(logoUrl);
            } catch (e) {
                console.warn('Nie udało się wczytać logo firmy, pomijam:', e);
            }
        }

        this._userSettings.next(userSettings);

        // Synchronizuj format daty z ustawień użytkownika
        const dateFormat = ObjectUtils.getNestedValue(userSettings, 'settings.general.dateFormat');
        if (dateFormat) {
            this._dateFormatService.setFormat(dateFormat);
        }
        
        // Aktualizuj też SubscriptionService
        if (userSettings.subscription) {
            this._subscriptionService.setSubscription(userSettings.subscription);
        } else {
            // Oznacz jako załadowane nawet bez subskrypcji (nowy użytkownik)
            this._subscriptionService.markAsLoaded();
        }
    }

    updateSettings(settings:string | Settings)
    {
        if(!Utils.isNullOrEmpty(settings)) settings = Utils.parseJSONToClass(<string>settings, Settings) || new Settings();
        this._userSettings.value.settings = <Settings>settings;
    }
}